/* eslint-disable max-classes-per-file */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Icon from 'react-native-vector-icons/MaterialIcons'

import {
  View,
  Text,
  StyleSheet,
  StatusBar,
  Animated,
  TouchableOpacity,
} from 'react-native'

import {
  getCurrentNotification,
  clickNotification,
  hideNotification,
} from '../ducks/notifications'

import { normalizeColor } from '../utils/colors'

class NotificationItem extends Component {
  state = {
    position: new Animated.Value(-100),
  }

  handlePress = () => {
    const { position } = this.state
    const { clickNotification } = this.props

    Animated.timing(position, {
      toValue: -100,
      duration: 200,
      useNativeDriver: true,
    }).start(() => {
      clickNotification()
    })
  }

  componentDidMount() {
    const { position } = this.state
    const { hideNotification } = this.props

    Animated.timing(position, {
      toValue: 0,
      duration: 500,
      useNativeDriver: true,
    }).start()

    this.timer = window.setTimeout(() => {
      Animated.timing(position, {
        toValue: -100,
        useNativeDriver: true,
      }).start(() => {
        hideNotification()
      })
    }, 5000)
  }

  componentWillUnmount() {
    window.clearTimeout(this.timer)
  }

  render() {
    const { position } = this.state
    const { notification } = this.props
    const { title, body } = notification

    const paddingStyles = {
      paddingTop: 40,
    }

    return (
      <Animated.View style={{ transform: [{ translateY: position }] }}>
        <TouchableOpacity onPress={this.handlePress} activeOpacity={0.7}>
          <View style={[styles.notification, paddingStyles]}>
            <View style={styles.contentContainer}>
              <View style={styles.textContainer}>
                {title && <Text style={styles.title}>{title}</Text>}
                {body && <Text style={styles.body}>{body}</Text>}
              </View>
              <Icon
                name="chevron-right"
                size={24}
                color={normalizeColor('@textLight')}
                style={styles.icon}
              />
            </View>
            <StatusBar barStyle="dark-content" />
          </View>
        </TouchableOpacity>
      </Animated.View>
    )
  }
}

class Notifications extends Component {
  render() {
    const { notification, clickNotification, hideNotification } = this.props

    if (!notification) {
      return null
    }

    return (
      <>
        {[
          <NotificationItem
            key={`${notification.id}`}
            notification={notification}
            clickNotification={clickNotification}
            hideNotification={hideNotification}
          />,
        ]}
      </>
    )
  }
}

const styles = StyleSheet.create({
  notification: {
    backgroundColor: normalizeColor('@background'),
    paddingTop: 12,
    paddingBottom: 12,
    paddingLeft: 16,
    paddingRight: 16,
    elevation: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    borderLeftWidth: 4,
    borderLeftColor: normalizeColor('@primary'),
  },
  contentContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  textContainer: {
    flex: 1,
    marginRight: 8,
  },
  title: {
    fontSize: 16,
    fontWeight: '600',
    color: normalizeColor('@text'),
    marginBottom: 4,
  },
  body: {
    fontSize: 14,
    fontWeight: '400',
    color: normalizeColor('@textLight'),
    lineHeight: 20,
  },
  icon: {
    marginLeft: 8,
  },
})

const mapStateToProps = state => ({
  notification: getCurrentNotification(state),
})

export default connect(mapStateToProps, {
  clickNotification,
  hideNotification,
})(Notifications)
